import { render, staticRenderFns } from "./YourOwnership.vue?vue&type=template&id=2da70d48&"
import script from "./YourOwnership.vue?vue&type=script&lang=js&"
export * from "./YourOwnership.vue?vue&type=script&lang=js&"
import style0 from "./YourOwnership.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports